import { pushToDataLayer } from '../../pushToDataLayer';
import { GTMEvent, GTMEventAttributes, GTMEventName } from '../../types';

export function discardVideoEvent() {
  const eventAttributes: GTMEventAttributes = {
    event: GTMEvent.COVIDEO_EVENT,
    event_name: GTMEventName.DISCARD_VIDEO,
  };

  pushToDataLayer({
    ...eventAttributes,
  });
}
